import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import PermissionService from "services/permission.service";
import { ISavePermission } from "models/church.types";

export default function PermissionRegister() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [permission, setPermission] = useState<ISavePermission>({
    name: "",
    description: "",
  });

  // État pour la validation
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!permission.name || permission.name.trim().length < 3) {
      newErrors.name = "Le nom doit contenir au moins 3 caractères";
    } else if (permission.name.length > 50) {
      newErrors.name = "Le nom ne doit pas dépasser 50 caractères";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.warning("Veuillez vérifier les informations saisies");
      return;
    }

    try {
      setLoading(true);
      await PermissionService.create(permission);
      toast.success("Permission créée avec succès");
      history.push("/admin/permissions");
    } catch (error) {
      console.error("Erreur creation permission:", error);
      toast.error("Erreur lors de la création de la permission");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-4 w-full mt-6 min-h-screen">
      <div className="w-full max-w-xl">
        <div className="relative flex flex-col bg-[#0B1222] border border-white/10 rounded-[1.5rem] shadow-2xl overflow-hidden">
          {/* HEADER */}
          <div className="bg-[#0F172A]/60 px-8 py-5 border-b border-white/5 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center border border-[#D4AF37]/20">
                <i className="fas fa-shield-alt text-[#D4AF37] text-xs"></i>
              </div>
              <h2 className="text-white text-sm font-black uppercase tracking-[0.15em]">
                Nouvelle Permission
              </h2>
            </div>
            <button
              onClick={() => history.goBack()}
              className="text-slate-500 hover:text-white transition-colors"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <form className="p-8 lg:p-10" onSubmit={handleSubmit} noValidate>
            <div className="space-y-6">
              {/* NOM DE LA PERMISSION */}
              <div className="space-y-2">
                <label className="text-[9px] text-[#D4AF37] uppercase font-black tracking-widest ml-1">
                  NOM DE LA PERMISSION
                </label>
                <input
                  type="text"
                  value={permission.name}
                  onChange={(e) => {
                    setPermission({
                      ...permission,
                      name: e.target.value.toUpperCase().replace(/\s+/g, "_"),
                    });
                    if (errors.name)
                      setErrors((prev) => ({ ...prev, name: "" }));
                  }}
                  className={`w-full bg-[#161F32]/50 border ${errors.name ? "border-red-500" : "border-white/5"} rounded-xl px-4 py-3 text-sm text-white focus:border-[#D4AF37] outline-none transition-all font-mono uppercase`}
                  placeholder="EX: CAN_EDIT_USER"
                />
                {errors.name && (
                  <span className="text-red-500 text-[8px] font-bold uppercase ml-1 block">
                    {errors.name}
                  </span>
                )}
              </div>

              {/* DESCRIPTION */}
              <div className="space-y-2">
                <label className="text-[9px] text-[#D4AF37] uppercase font-black tracking-widest ml-1">
                  Description / Rôle de la permission
                </label>
                <textarea
                  value={permission.description}
                  onChange={(e) =>
                    setPermission({
                      ...permission,
                      description: e.target.value,
                    })
                  }
                  rows={4}
                  className="w-full bg-[#161F32]/50 border border-white/5 rounded-xl px-4 py-3 text-sm text-white focus:border-[#D4AF37] outline-none transition-all resize-none"
                  placeholder="Expliquez brièvement ce que cette permission autorise..."
                />
              </div>

              {/* INFO BOX */}
              <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-4 flex gap-4 items-start">
                <i className="fas fa-info-circle text-blue-400 mt-1"></i>
                <p className="text-[10px] text-slate-400 leading-relaxed font-bold uppercase tracking-tight">
                  Les permissions sont des jetons atomiques. Une fois créées,
                  elles peuvent être regroupées au sein de rôles pour être
                  assignées aux utilisateurs.
                </p>
              </div>

              {/* ACTIONS */}
              <div className="flex items-center justify-end pt-6 mt-4 border-t border-white/5 gap-4">
                <button
                  type="button"
                  onClick={() => history.goBack()}
                  className="px-6 py-2.5 text-[10px] font-black uppercase text-slate-500 hover:text-white transition-colors"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-[#D4AF37] text-[#0B1222] px-10 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-[0.2em] shadow-lg shadow-[#D4AF37]/10 hover:scale-105 transition-all disabled:opacity-50"
                >
                  {loading ? "Enregistrement..." : "Enregistrer"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
